import React, { useEffect } from "react";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Pages
import ServicesPage from "./pages/ServicesPage";
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import AboutUsPage from "./pages/AboutUsPage";
import BlogMainPage from "./pages/BlogMainPage";
import OurWorkPage from "./pages/OurWorkPage";
import BlogSubPage from "./pages/BlogSubPage";
import WorkSubPage from "./pages/WorkSubPage";
import DevelopmentServicePage from "./pages/DevelopmentServicePage";
import HrServicePage from "./pages/HrServicePage";
import InternshipProgramPage from "./pages/InternshipProgramPage";
import InternshipApplication from "./pages/InternshipApplicationPage";
import { BrowserRouter } from "react-router-dom";

// GA helper
const GA_MEASUREMENT_ID = "G-CBCVK421DH"; // Your GA4 ID

const logPageView = (path) => {
  if (window.gtag) {
    window.gtag("config", GA_MEASUREMENT_ID, { page_path: path });
  }
};

// Component to track route changes
const GAListener = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // For HashRouter, location.hash includes "#/", remove "#" for GA
    const path = location.hash ? location.hash.replace("#", "") : "/";
    logPageView(path);
  }, [location]);

  return children;
};

function App() {
  return (
    <BrowserRouter>
      <GAListener>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/blog" element={<BlogMainPage />} />
          <Route path="/ourwork" element={<OurWorkPage />} />
          <Route path="/worksub/:slug" element={<WorkSubPage />} />
          <Route path="/blog/:slug" element={<BlogSubPage />} />
          <Route
            path="/developmentservice"
            element={<DevelopmentServicePage />}
          />
          <Route path="/hrservice" element={<HrServicePage />} />
          <Route
            path="/internshipprogram"
            element={<InternshipProgramPage />}
          />
          <Route
            path="/internshipapplication"
            element={<InternshipApplication />}
          />
        </Routes>
      </GAListener>
    </BrowserRouter>
  );
}

export default App;
